import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';

function VersionText({ version, loading }) {
  if (loading || !version) return null;
  return (
        <Grid container justifyContent='flex-end' sx={{ pr: '10px' }}>
            <Typography fontSize='16px' fontWeight='bold'>v{version}</Typography>
        </Grid>
  );
}

VersionText.propTypes = {
  version: PropTypes.string,
  loading: PropTypes.bool
};

export default VersionText;
